import axios from 'axios';

import { Locale, siteTranslation } from 'localisation';

const TIMEOUT = 1500;

export const getGeoInfo = (
  country: string | null,
  setCountry: (country: string) => void,
  locale: Locale,
) => {
  if (country) return Promise.resolve();

  let requestCompleted = false;

  // Выполнение запроса с таймаутом
  setTimeout(() => {
    if (!requestCompleted) {
      setCountry(locale === 'en' ? 'US' : 'RU');
    }
  }, TIMEOUT);

  return axios
    .get('https://api.country.is')
    .then(response => {
      requestCompleted = true;
      const country = response?.data?.country as string;
      setCountry(country || 'US');
    })
    .catch(error => {
      if (!requestCompleted) {
        console.error('Primary service error:', error);
      }
    });
};

export const getLocalisation = async (localisationUrl: string) => {
  try {
    const response = await axios.get(localisationUrl);
    const data = response.data;

    return {
      ru: {
        ...siteTranslation.ru,
        ...data.ru,
      },
      en: {
        ...siteTranslation.en,
        ...data.en,
      },
    };
  } catch (error) {
    console.error('Error fetching localisation:', error);
    throw error;
  }
};

export const getAssetsData = (
  assetsUrl: string,
  setAssetsData: (assetsData: any) => void,
) => {
  return axios.get(assetsUrl).then(({ data }) => {
    setAssetsData(data);
  });
};
